/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const innerContentFilter = () => {
  const btnsFitler = document.querySelectorAll('.btn-inner-filter-js');
  if (btnsFitler) {
    btnsFitler.forEach(btn => {
      btn.addEventListener('click', e => {
        const targetBtn = e.currentTarget.getAttribute('data-target');
        const items = document.querySelectorAll('.inner-content-js');
        const parent = e.currentTarget.parentElement;

        parent.querySelectorAll('.btn-inner-filter-js').forEach(item => {
          item.classList.remove('is-active');
        });

        items.forEach(el => {
          if (el.id === targetBtn) {
            const btnSibling = [...e.currentTarget.parentElement.children];
            btnSibling.forEach(btnTarget => {
              const idTarget = btnTarget.getAttribute('data-target');
              document.getElementById(idTarget).classList.remove('is-active');
            });
            el.classList.add('is-active');
          }
        });
        e.currentTarget.classList.add('is-active');
      });
    });
  }
};

export default innerContentFilter;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/inner-content-filter.js